<template>
  <div v-if="value.meta">
    <el-divider />
    <h3>Additional Details</h3>
    <span class="c-darkergreen">Gridiron Australia is collecting the below information for the purposes of applying for governments grants to reinvest back back into the sport</span>
    <el-row :gutter="60">
      <el-col :span="24" :md="12" class="mt-20">
        <el-input-title>National ID</el-input-title>
        <el-form-item prop="meta.nationalId">
          <el-input class="mt-05" v-model="value.meta.nationalId" placeholder="Gridiron National ID" />
        </el-form-item>
      </el-col>
      <el-col :span="24" :md="12" class="mt-20">
        <el-input-title>Home Club</el-input-title>
        <el-form-item prop="meta.homeClub">
          <el-select
            filterable
            remote
            reserve-keyword
            value-key="_id"
            class="mt-05 w-100"
            v-model="value.meta.homeClub"
            :remote-method="searchClub"
            placeholder="Select">
            <el-option
              v-for="{ _id, value } in clubs"
              :key="_id"
              :label="value"
              :value="{_id, value}">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="24" :md="12" class="mt-20">
        <el-input-title>Additional Emails</el-input-title>
        <el-form-item prop="meta.nationalId">
          <el-input class="mt-05" v-model="value.meta.additionalEmails" placeholder="Additional Emails" />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="60">
      <el-col :span="24" :md="12" class="mt-20">
        <el-form-item prop="meta.isAboriginal">
          <el-input-title required>Are you of Aboriginal and/or Torres Strait Islander origin?</el-input-title>
          <el-select class="mt-05" v-model="value.meta.isAboriginal" placeholder="Yes / No / Blank">
            <el-option v-for="e in yesNoOptions" :label="e.name" :key="e.name" :value="e.name" />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="24" :md="12" class="mt-20">
        <el-form-item prop="meta.hasAustralianPassport">
          <el-input-title required>Australian Passport</el-input-title>
          <el-select class="mt-05" v-model="value.meta.hasAustralianPassport" placeholder="Yes / No / Blank">
            <el-option v-for="e in hasPassportOptions" :label="e.name" :key="e.name" :value="e.name" />
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="60" v-if="value.meta.hasAustralianPassport === 'No'">
      <el-col :span="24" :md="12" class="mt-20">
        <el-form-item prop="meta.otherPassports" label="Other Passports">
            <el-select
              filterable
              remote
              reserve-keyword
              class="mt-05 w-100"
              v-model="value.meta.otherPassports"
              :remote-method="searchCountry"
              placeholder="Type to search"
            >
              <el-option
                v-for="item in countryItems"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="60">
      <el-col :span="24" :md="12" class="mt-20">
        <el-form-item prop="meta.religion">
          <el-input-title>Religion</el-input-title>
          <el-input class="mt-05" v-model="value.meta.religion" placeholder="Religion" />
        </el-form-item>
      </el-col>
      <el-col :span="24" :md="12" class="mt-20">
        <el-form-item prop="meta.occupation">
          <el-input-title>Occupation</el-input-title>
          <el-input class="mt-05" v-model="value.meta.occupation" placeholder="Occupation" />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="60">
      <el-col :span="24" :md="12" class="mt-20">
        <el-form-item prop="meta.householdIncome">
          <el-input-title>Household Income</el-input-title>
          <el-select class="mt-05" v-model="value.meta.householdIncome" placeholder="Household Income" clearable>
            <el-option label="0-100k" value="0-100k" />
            <el-option label="100-200k" value="100-200k" />
            <el-option label="200k+" value="200k+" />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="24" :md="12" class="mt-20">
        <el-form-item prop="meta.currentSports">
          <el-input-title>Other Sports Played Currently</el-input-title>
          <el-input class="mt-05" v-model="value.meta.currentSports" placeholder="Other Sports Played Currently" />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="60">
      <el-col :span="24" :md="12" class="mt-20">
        <el-form-item prop="meta.previousSports">
          <el-input-title>Other Sports Played Previously</el-input-title>
          <el-input class="mt-05" v-model="value.meta.previousSports" placeholder="Other Sports Played Previously" />
        </el-form-item>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { get } from 'lodash';
import playerDetails from '@/mixins/player-details';
import { countries } from '@/utils/constants';

export default {
  name: 'GridironExtra',
  mixins: [playerDetails],
  props: ['value', 'refs'],
  data() {
    return {
      clubs: [],
      countries,
      yesNoOptions: [
        { name: 'Yes', value: 'Yes' },
        { name: 'No', value: 'No' },
        { name: 'Blank', value: 'Blank' }
      ],
      hasPassportOptions: [
        { name: 'Yes', value: 'Yes' },
        { name: 'No', value: 'No' },
        { name: 'Blank', value: 'Blank' }
      ],
      countryItems: [],
    };
  },
  mounted() {
    this.$http.post('/assemble/api/v1/portal/clubs/search', { criteria: '' }).then((res) => {
      const data = res.data.data.map((c) => ({ value: c.name, _id: c._id, meta: { code: get(c, 'meta.code') } }));
      // Append none
      data.unshift({ value: 'None', _id: 'none' });
      this.clubs = data;
    }).catch(() => {});
  },
  methods: {
    searchCountry(query) {
      if (query !== '') {
        setTimeout(() => {
          this.countryItems = this.countries.filter(
            (item) => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1
          );
        }, 200);
      } else {
        this.countryItems = [];
      }
    },
    searchClub(query) {
      this.$http.post('/assemble/api/v1/portal/clubs/search', { criteria: query }).then((res) => {
        const data = res.data.data.map((c) => ({ value: c.name, _id: c._id, meta: { code: get(c, 'meta.code') } }));
        // Append none
        data.unshift({ value: 'None', _id: 'none' });
        this.clubs = data;
      }).catch(() => {});
    },
  },
  computed: {

  }
};
</script>

<style lang="scss" scoped>

.el-autocomplete,
.el-select,
.el-input {
  width: 100%;
}

</style>
